export enum TransferPermissions {
  ALL = "Travel:Transfers:*",
  READ = "Travel:Transfers:Read",
  WRITE = "Travel:Transfers:Write",
}

export function hasTransferAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [TransferPermissions.READ, TransferPermissions.ALL, "*"].includes(p)
  );
}
